import { useContext } from 'react';
import { useStore } from 'zustand';

import { MatchesCouponContext } from '../context';
import { type MatchesCouponState } from '../interfaces/matches-coupon.interface';

export function useMatchesCouponContext<T>(
  selector: (state: MatchesCouponState) => T,
  equalityFn?: (left: T, right: T) => boolean,
): T {
  const store = useContext(MatchesCouponContext);
  if (!store) throw new Error('Missing MatchesCouponContext.Provider in the tree');
  return useStore(store, selector, equalityFn);
}
